import { render, staticRenderFns } from "./ModalCriarEsclarecimentoImpugnacaoServidor.vue?vue&type=template&id=13df3668"
import script from "./ModalCriarEsclarecimentoImpugnacaoServidor.vue?vue&type=script&lang=js"
export * from "./ModalCriarEsclarecimentoImpugnacaoServidor.vue?vue&type=script&lang=js"
import style0 from "./ModalCriarEsclarecimentoImpugnacaoServidor.vue?vue&type=style&index=0&id=13df3668&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports